import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createPageUrl } from '../utils';

export default function HeroSection({ hero }) {
  const navigate = useNavigate();

  if (!hero || !hero.is_enabled) return null;

  const handleButtonClick = (linkType, linkValue) => {
    if (!linkValue) return;
    
    if (linkType === 'internal_page') {
      navigate(createPageUrl(linkValue));
    } else {
      window.location.href = linkValue;
    }
  };

  return (
    <div className="relative w-full h-48 lg:h-80 overflow-hidden">
      {/* Background Image — a real <img> so the browser's preload scanner can
          discover and prioritise it (this is the page's LCP element). */}
      {hero.image_url && (
        <img
          src={hero.image_url}
          alt=""
          aria-hidden="true"
          fetchpriority="high"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center px-3">
        <div className="text-center max-w-xs lg:max-w-2xl">
          {hero.heading && (
            <h1 className="text-xl lg:text-5xl font-bold mb-2 lg:mb-4 text-white" style={{ fontFamily: 'Georgia, serif' }}>
              {hero.heading}
            </h1>
          )}

          {hero.subheading && (
            <p className="text-sm lg:text-xl mb-4 lg:mb-8 text-white" style={{ fontFamily: 'Georgia, serif' }}>
              {hero.subheading}
            </p>
          )}

          {/* Buttons */}
          <div className="flex flex-row gap-2 lg:gap-4 justify-center">
          {hero.button_1_text && hero.button_1_link_value && (
            <button
              onClick={() => handleButtonClick(hero.button_1_link_type, hero.button_1_link_value)}
              className="px-3 lg:px-8 py-1.5 lg:py-3 text-white rounded-lg font-semibold text-xs lg:text-base hover:opacity-90 transition-colors"
              style={{ backgroundColor: '#1A2744' }}
            >
              {hero.button_1_text}
            </button>
          )}

          {hero.button_2_text && hero.button_2_link_value && (
            <button
              onClick={() => handleButtonClick(hero.button_2_link_type, hero.button_2_link_value)}
              className="px-3 lg:px-8 py-1.5 lg:py-3 text-white rounded-lg font-semibold text-xs lg:text-base hover:opacity-90 transition-colors"
              style={{ backgroundColor: '#1A2744' }}
            >
              {hero.button_2_text}
            </button>
          )}
            </div>
            </div>
            </div>
            </div>
            );
            }